import EFPicture from 'elem/compCommon/EFPicture';
import { subscribe, sendSubscribeGet } from '@/service/vip';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';
import { sendMultiEmarsysEmail } from '@elem/ui/ef-emarsys-email/apis';
import moment from 'moment';

const Icon4 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect width="20" height="20" rx="10" fill="#30BF00" />
        <path d="M15 6.66699L8.125 14.167L5 10.7579" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default function D() {
    const { useLang, Link, gtm, useState } = useGlobal();
    const { locale } = getLocal();
    const [email, setEmail] = useState('');
    const [errorEmail, setErrorEmail] = useState(false);
    const [isSucc, setIsSucc] = useState(false);
    const [checked, setChecked] = useState(true);
    const { t } = useLang('powerpreparedness');
    const LINK = 'https://us.ecoflow.com/pages/home-backup-sale';
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const date = moment(systemTime).format('YYYY-MM-DD') as any;
    const SendEmarsysEmail = async () => {
        const data = {
            fields: [
                {
                    type: 'single',
                    id: '4424',
                    value: 1,
                    overwrite: true,
                },
                {
                    type: 'single',
                    id: '31',
                    value: 1,
                    overwrite: false,
                },
                {
                    type: 'multiple',
                    id: '9435',
                    value: [57],
                    overwrite: false,
                },
                // 订阅日期
                {
                    id: '9626',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
            source: 'WEB_NEW_PRODUCT_SUB',
            contactListId: '1402194168',
            email: email,
        };
        const res: any = await sendMultiEmarsysEmail(
            locale,
            {
                ...data,
            },
            {
                entry_position: 6,
                sector_name: t.rich('secD_title', {
                    blue: (text: string) => text,
                }),
            },
        );
        return res;
    };
    const onSubmit = async () => {
        if (!email) {
            setErrorEmail(true);
            return;
        }
        if (!checked) {
            return;
        }
        if (!errorEmail && email) {
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: 'Sign up',
                    status: 'success',
                    tag: 'None',
                });
                if (locale !== 'ca') {
                    const res = await subscribe(email, locale, 'WEB_CAMPAIGN_SUB', {
                        sector_name: t.rich('secD_title', {
                            blue: (text: string) => text,
                        }),
                        entry_position: 6,
                    });
                    sendSubscribeGet(email);
                    setIsSucc(true);
                    setTimeout(() => {
                        setEmail('');
                        setIsSucc(false);
                        window.open(LINK, '_blank');
                    }, 1000);
                } else {
                    const res = await SendEmarsysEmail();
                    if (res?.code === '0') {
                        setEmail('');
                        setIsSucc(false);
                    }
                }

                // @ts-ignore
                twq('event', 'tw-o9mqq-ojfq3', {});
            } catch (error) {}
        }
    };

    return (
        <div
            id="power-preparedness-D"
            className={`power-preparedness-D ${css['power-preparedness-D']} page-layout GtmModuleData-section`}
            data-section-id={'powerPreparedness-D'}
            data-section-title={t('secD_title')}
        >
            <div className="page-space"></div>
            <div className="wrapper-box">
                <div className="preparedness-d-img">
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1739415632298/pc_Frame%20161269437.png"
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1739415480641/m_Frame%20161269456.png"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1739415480641/m_Frame%20161269456.png"
                        alt="Sign up to unlock special deals on more EcoFlow backup solutions!"
                    />
                </div>

                <div className="wrapper">
                    <div className="title">
                        {t.rich('secD_title', {
                            blue: (text: string) => <p className="blue">{text}</p>,
                        })}
                    </div>

                    <div className="email-box">
                        <div className="text-wrapper">
                            {isSucc && (
                                <div className={`succ ${isSucc ? 'show' : ''}`}>
                                    <Icon4 />
                                    <p>{t('secG_email_thx')}</p>
                                </div>
                            )}
                            <div className="email-input-box">
                                {' '}
                                <input
                                    className={`email-input ${errorEmail ? 'error' : ''}`}
                                    type="text"
                                    value={email}
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        const regx =
                                            /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                                        if (value && !regx.test(value)) {
                                            setIsSucc(false);
                                            setErrorEmail(true);
                                        } else {
                                            setErrorEmail(false);
                                        }
                                        setEmail(value);
                                    }}
                                    placeholder={t('secG_email_placeholder')}
                                />
                                <button disabled={errorEmail} onClick={onSubmit}>
                                    {t('secD_sign_up')}
                                </button>
                            </div>
                            {errorEmail && (
                                <div className="error-box">
                                    <p>{'Please enter a valid email address.'}</p>
                                </div>
                            )}

                            <div className="tips">
                                <input type="checkbox" checked={checked} onClick={() => setChecked(!checked)} />
                                <p>
                                    {t.rich('secG_email_tips', {
                                        link1: (text: string) => (
                                            <Link className="link" href={`https://account.ecoflow.com/agreement/en-${locale}/TermsOfUse.html`} target="_blank">
                                                {text}
                                            </Link>
                                        ),
                                        link2: (text: string) => (
                                            <Link
                                                className="link"
                                                href={`https://account.ecoflow.com/agreement/en-${locale}/PrivacyPolicy.html`}
                                                target="_blank"
                                            >
                                                {text}
                                            </Link>
                                        ),
                                    })}
                                </p>
                            </div>

                            {!checked && (
                                <div className="tips-box">
                                    <p>{`Please accept EcoFlow's Terms of Service and Privacy Policy.`}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
